import OneNetworkConfig from '@/onenetwork/core/onenetwork.config.ts'
import PrivateRouter from '@/onenetwork/layouts/PrivateRouter.vue'
import CsList from '@/modules/cs/views/CsList.vue'
import PopupList from '@/modules/cs/views/PopupList.vue'


const baseRoute = OneNetworkConfig.baseRoutePath
const accountRouter = [
  {
    path: `${baseRoute}/cs/bulk-messages`,
    name: 'cs-bulk-messages',
    meta: {
      component: CsList
    },
    component: PrivateRouter,
  },
  {
    path: `${baseRoute}/cs/popup`,
    name: 'cs-popup',
    meta: {
      component: PopupList
    },
    component: PrivateRouter,
  },
]
export default accountRouter
